import React, { PureComponent } from 'react'
import { FormControl, InputLabel, Input } from '@material-ui/core'

import ForwardRefHOC from '../../containers/HOC/ForwardRefHOC'
import ModalDialog from '../common/ModalDialog'
import { EditableReactSelectAsync } from '../common/EditableComponents'

class AddMetrcEmployeeModal extends PureComponent {
  timeout = null
  state = {
    userApiKey: '',
    employeeId: '',
    selectedEmployee: null,
  }

  saveEmployeeKey = () => {
    const { userApiKey, employeeId } = this.state
    this.props.onSaveEmployeeKey({ userApiKey, employeeId })
  }

  onClose = () => {
    this.setState({
      userApiKey: '',
      employeeId: '',
      selectedEmployee: null,
    })
  }

  onOpen = (type) => {
    this.setState({
      userApiKey: '',
      employeeId: '',
      selectedEmployee: null,
    })
  }

  onChange = (key) => (e) => {
    this.setState({
      [key]: e.target.value,
    })
  }

  onChangeEmployee = (e) => {
    const id = e && e.id ? e.id : null
    this.setState({
      employeeId: id,
      selectedEmployee: e,
    })
  }

  loadEmployees = (term, callback) => {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    if (term.length === 0) {
      const { employees = [] } = this.props
      const options = this.getEmployeeList(employees)
      callback(null, { options })
      return
    }

    this.timeout = setTimeout(() => {
      this.props.onEmployeeSearch(term).then((res) => {
        let options = res && res.values ? this.getEmployeeList(res.values) : []
        callback(null, { options })
      })
    }, 500)
  }

  getEmployeeList = (employees) => {
    console.log('employees', employees)
    return (
      (employees &&
        employees.length &&
        employees
          .filter((employee) => !employee.disabled)
          .map((employee) => ({
            ...employee,
            label: `${employee.firstName} ${employee.lastName}`,
            value: employee.id,
          }))) ||
      []
    )
  }

  render() {
    const { forwardedRef, employees = [] } = this.props

    const { userApiKey, selectedEmployee = null } = this.state

    return (
      <ModalDialog
        title={'Add Metrc Employee Key'}
        ref={forwardedRef}
        onConfirm={this.saveEmployeeKey}
        onClose={this.onClose}
        onOpen={this.onOpen}
        className={'modal-overflow'}
      >
        <FormControl fullWidth className="margin-bottom-small">
          <EditableReactSelectAsync
            options={this.getEmployeeList(employees)}
            value={selectedEmployee}
            onChange={this.onChangeEmployee}
            editMode={true}
            MenuProps={{ className: 'no-backdrop-select' }}
            autoload={false}
            loadOptions={this.loadEmployees}
            onBlurResetsInput={false}
            cache={false}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Select Employee..."
            portalPlacement={'bottom'}
          />
        </FormControl>
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Metrc API Key *</InputLabel>
          <Input value={userApiKey} onChange={this.onChange('userApiKey')} fullWidth />
        </FormControl>
      </ModalDialog>
    )
  }
}

export default ForwardRefHOC(AddMetrcEmployeeModal)



// WEBPACK FOOTER //
// ./src/components/Metrc/AddMetrcEmployeeModal.js